import Personal from "../vue/Personal/Personal.vue";
import Vue from "vue";

export default {
  init() {
    new Vue({
      el: "#personal-area-placeholder",
      components: { Personal },
      template: "<Personal />"
    });
  }
};
